module.exports = __webpack_public_path__ + "media/images/thumbs/muscles/pleg16-37e280542227e1ae59c345d387ddd574.jpg";